import { useQuery } from '@tanstack/react-query'
import { QUERIES } from '@/constants/queries'
import { getStudentOpenRequestEligibilityByType } from '@/services/requests/get-student-open-request-eligibility'
import { getStudentRequests } from '@/services/requests/get-student-requests'
import { toastService } from '@/toasts/toastService'

export const useStudentHome = () => {
  const { data, isFetching } = useQuery({
    queryKey: [QUERIES.QUERY_GET_STUDENT_REQUESTS],
    queryFn: getStudentRequests
  })

  const {
    data: studentEligibilityData,
    isLoading: studentEligibilityIsLoading
  } = useQuery({
    queryKey: [QUERIES.QUERY_GET_STUDENT_OPEN_REQUEST_ELIGIBILITY],
    queryFn: getStudentOpenRequestEligibilityByType,
    refetchOnMount: 'always'
  })

  function getRequestTypeEligibility(requestTypeId: string) {
    if (!studentEligibilityData) return null

    return studentEligibilityData[requestTypeId]
  }

  function verifyRequestEligibility(requestId: string, requestName: string) {
    const eligibility = getRequestTypeEligibility(requestId)

    if (!eligibility) return false

    if (!eligibility.allowed) {
      toastService.thereIsAlreadyAnRequestInAnalysis(requestName)
      return false
    }

    return true
  }

  const isPageLoading = isFetching || studentEligibilityIsLoading

  return {
    states: {
      data,
      isPageLoading
    },
    actions: { verifyRequestEligibility }
  }
}
